// Display-only mirror of Compass's canonical application/module registry
// (../Compass/packages/compass-product-registry). Compass owns the
// definition; validation of what may actually be written happens
// server-side in Compass's own setEntitlement Cloud Function, which
// imports the registry directly (same repo) — this file exists only so
// Manage's UI can show a module's real name without a cross-repo package
// dependency, which isn't justified yet for five rarely-changing entries.
// See ../../README.md's "Product architecture ownership" section. If this
// list and the canonical registry ever diverge, the registry is correct.
export const COMPASS_APPLICATION_KEY = 'compass';

export interface ModuleDisplay {
  key: string;
  displayName: string;
}

export const COMPASS_MODULES: ModuleDisplay[] = [
  { key: 'operations', displayName: 'Operations' },
  { key: 'training', displayName: 'Training' },
  { key: 'advancement', displayName: 'Advancement' },
  { key: 'initiatives', displayName: 'Initiatives' },
  { key: 'communications', displayName: 'Communications' },
];
